import type { BootStrategies } from 'owa-shared-start';
import type { PromiseWithKey } from 'owa-performance';

export function preloadStrategies(
    strategies: BootStrategies | undefined
): PromiseWithKey<unknown>[] {
    const promises: PromiseWithKey<unknown>[] = [];
    if (strategies) {
        for (let strategy of Object.keys(strategies)) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS7053 (13,32): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'BootStrategies'.
            // @ts-expect-error
            const lazyAction = strategies[strategy];
            if (lazyAction) {
                promises.push({
                    promise: lazyAction.import(),
                    key: strategy,
                });
            }
        }
    }
    return promises;
}
